import * as React from "react";
import { TextField } from "react-admin";
import { subResourceList } from "../_subresource";
import { FrDateField } from "../../components/FrDateField";

// GET /echos/{echoId}/comments (page 1-indexée + limit, lecture seule).
export default {
  list: subResourceList({
    parentParam: "echoId",
    parentLabel: "ID écho",
    children: [
      <TextField key="content" source="content" label="Commentaire" />,
      <TextField key="author" source="authorDisplayName" label="Auteur" />,
      <TextField key="authorId" source="authorId" label="ID auteur" />,
      <FrDateField key="createdAt" source="createdAt" label="Date" showTime />,
    ],
  }),
};
